// ADDED
import React from "react";
import { GeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { useSalaryAdvanceAccess } from "../../hooks/useSalaryAdvanceAccess";
import SalaryAdvanceAccessModule from "../../components/modules/SalaryAdvanceAccess/SalaryAdvanceAccessModule";

const SalaryAdvanceAccessPage = ({ user, isHideSideMenu }) => {
  const accessMethods = useSalaryAdvanceAccess();

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            <div className="mainteHeader p-4 border-b">
              <div className='sub-title row text-sm'>
                <span className="text-gray-400">{"Maintenance > "}</span>
                <span className="border-b border-black">{"Salary Advance Access"}</span>
              </div>
              <h3 className="text-xl font-bold mt-2">Salary Advance Access</h3>
            </div>

            <SalaryAdvanceAccessModule
              user={user}
              {...accessMethods}
            />
          </div>
        </div>
      </div>

      <GeneralMessage
        form={accessMethods.showMessage}
        message={accessMethods.message}
        isSuccess={accessMethods.isSuccess}
      />

      <LoadingSpinner loading={accessMethods.loading} />
    </>
  );
};

export default SalaryAdvanceAccessPage;